export const removeCharactersFromPhone = (phone: string): string =>
  phone.replace(/[^a-zA-Z0-9]*/g, '');

export const alphabetToTelNumber = (char: string) => {
  switch (char.toLowerCase()) {
    case 'a':
    case 'b':
    case 'c':
      return '2';
    case 'd':
    case 'e':
    case 'f':
      return '3';
    case 'g':
    case 'h':
    case 'i':
      return '4';
    case 'j':
    case 'k':
    case 'l':
      return '5';
    case 'm':
    case 'n':
    case 'o':
      return '6';
    case 'p':
    case 'q':
    case 'r':
    case 's':
      return '7';
    case 't':
    case 'u':
    case 'v':
      return '8';
    case 'w':
    case 'x':
    case 'y':
    case 'z':
      return '9';
    default:
      return char;
  }
};

export const formatPhoneNumberAsLink = (tel: string) =>
  `tel:+1${tel
    .split('')
    .map(removeCharactersFromPhone)
    .map(alphabetToTelNumber)
    .join('')}`;
